module.exports = __webpack_public_path__ + "img/1444433461.969a2048.jpg";